import React from "react";
import Header from "../components/Header";
import Post from "../components/Post";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div>
      <Header />
      <Post />
      <Footer />
    </div>
  );
}
